/** Russian strings of the AI agent's files screen. See `uz-ai-files.ts`. */
import type { uzAiFiles } from "./uz-ai-files";

export const ruAiFiles: Record<keyof typeof uzAiFiles, string> = {
  "aiFiles.title": "Файлы",
  "aiFiles.intro":
    "ИИ работает по инструкциям из этих файлов. Сохранение пишет в черновик: до публикации на ответы не влияет.",
  "aiFiles.noPermission": "Этот раздел видят только владелец агентства и менеджеры.",
  "aiFiles.retry": "Повторить",
  "aiFiles.list": "Файлы агента",
  "aiFiles.group.jobs": "Файлы задач",
  "aiFiles.group.shared": "Общие файлы",
  "aiFiles.changed": "Изменён",
  "aiFiles.unsaved": "Не сохранён",
  "aiFiles.source.draft": "v{number} · черновик",
  "aiFiles.source.published": "v{number} · опубликована",
  "aiFiles.source.archived": "v{number} · архив",
  "aiFiles.source.none": "Настроек пока нет",
  "aiFiles.source.knowledge": "Из базы знаний",
  "aiFiles.draftNotice": "Черновик v{number}: изменено файлов: {count}.",
  "aiFiles.toPublish": "Перейти к публикации",
  "aiFiles.mode.label": "Вид файла",
  "aiFiles.mode.edit": "Редактор",
  "aiFiles.mode.merged": "Объединённый вид",
  "aiFiles.mode.history": "Версии",
  "aiFiles.editor.label": "Содержимое: {title}",
  "aiFiles.editor.json": "Этот файл хранится в формате JSON.",
  "aiFiles.editor.formHint": "Удобная форма для тона и фраз",
  "aiFiles.editor.invalidJson": "JSON некорректен, файл не отправлен. Проверьте скобки и кавычки.",
  "aiFiles.save": "Сохранить",
  "aiFiles.cancel": "Отмена",
  "aiFiles.saved": "Сохранено в черновик. До публикации на ответы не влияет.",
  "aiFiles.warnings.title": "Предупреждения",
  "aiFiles.warnings.hint":
    "Текст сохраняется и доходит до модели, но ответ, нарушающий правило, платформа клиенту всё равно не отправит.",
  "aiFiles.merged.task": "Задача",
  "aiFiles.merged.noTask": "Без задачи",
  "aiFiles.merged.channel": "Канал",
  "aiFiles.merged.noChannel": "Обычное сообщение",
  "aiFiles.merged.comment": "Комментарий Instagram",
  "aiFiles.merged.layers": "Слои: {layers}",
  "aiFiles.merged.draftNote": "По черновику: после публикации агент будет читать это.",
  "aiFiles.merged.liveNote": "Сейчас агент читает это.",
  "aiFiles.merged.unsavedNote": "Несохранённые изменения здесь не видны.",
  "aiFiles.layer.platform": "Платформа",
  "aiFiles.layer.agency": "Агентство",
  "aiFiles.layer.task": "Задача",
  "aiFiles.layer.branch": "Филиал",
  "aiFiles.layer.channel": "Канал",
  "aiFiles.history.list": "Версии файла",
  "aiFiles.history.empty": "Для этого файла версий нет.",
  "aiFiles.history.current": "текущая",
  "aiFiles.history.draft": "черновик",
  "aiFiles.history.changedHere": "Изменён в этой версии",
  "aiFiles.history.absent": "В этой версии файла нет",
  "aiFiles.history.restore": "Вернуть версию v{number}",
  "aiFiles.history.confirmTitle": "Вернуть версию v{number}",
  "aiFiles.history.confirmBody":
    "Файл «{title}» в черновике будет заменён содержимым v{number}. Другие файлы не затрагиваются, ничего не публикуется.",
  "aiFiles.history.restored": "Файл возвращён в черновик.",
  "aiPublish.label": "Публикация черновика",
  "aiPublish.notice": "Черновик v{number} ещё не опубликован.",
  "aiPublish.action": "Опубликовать",
  "aiPublish.done": "Черновик опубликован",
  "aiPublish.toTests": "Центр тестов",
};
